export class User {
    UserId: number;
    UserName: string;
    ForcePasswordReset: boolean;
    IsLocked: boolean
    IsOhlEmployee: boolean;
    FirstName: string;
    LastName: string;
    Email: string;
    IsPortalUser: string;
    Token: string;
    Status: string;
    UserAccessLevels: any[] = [];
    EULA: any | null;
}


// WEBPACK FOOTER //
// ./src/app/models/UserObj.ts